import encodeChars from './encodeChars';

export default {
  encode(data, {name}) {
    const key = encodeChars.colon(name);
    const val = data.value;
    return [key, val];
  },
  decode(value, {settings}) {
    return {
      type: settings.type,
      value,
    };
  },
};
